import React, { Component } from 'react';
import './IconsAlerts.css';

class IconsAlerts extends Component {
  render() {
    return (
      <svg style={{ display: 'none' }} viewBox="0 0 117.92 82.18">
        <defs>
          <symbol id="HA_file" viewBox="-24.1 -24.1 48.2 48.2">
            <circle className="IconsAlerts-0" cx="0" cy="0" r="20.7" />
            <circle className="IconsAlerts-1" cx="0" cy="0" r="16.9" />
            <line className="IconsAlerts-0" x1="0" y1="-24.1" x2="0" y2="-15" />
            <line className="IconsAlerts-0" x1="0" y1="15" x2="0" y2="24.1" />
            <line className="IconsAlerts-0" x1="-15" y1="0" x2="-24.1" y2="0" />
            <line className="IconsAlerts-0" x1="15" y1="0" x2="24.1" y2="0" />
            <polyline className="IconsAlerts-2" points="4.1,-10.8 4.1,-7 7.8,-7 	" />
            <path
              className="IconsAlerts-2"
              d="M7.8,10c0,0.4-0.3,0.7-0.7,0.7c0,0,0,0,0,0H-7.1c-0.4,0-0.7-0.3-0.7-0.7v-20c0-0.4,0.3-0.7,0.7-0.7		c0,0,0,0,0,0H4.1c0.2,0,0.3,0.1,0.4,0.2l3.1,3c0.1,0.1,0.2,0.3,0.2,0.5V10z"
            />
            <line className="IconsAlerts-2" x1="4.7" y1="-0.4" x2="-4.7" y2="-0.4" />
            <line className="IconsAlerts-2" x1="4.7" y1="2.6" x2="-4.7" y2="2.6" />
            <line className="IconsAlerts-2" x1="4.7" y1="5.6" x2="-4.7" y2="5.6" />
            <line className="IconsAlerts-2" x1="0.5" y1="-3.4" x2="-4.7" y2="-3.4" />
          </symbol>
          <symbol id="MA_file" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-4" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-5" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-4" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-4" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-4" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-4" x1="11.7" y1="0" x2="17.9" y2="0" />
            <polyline className="IconsAlerts-6" points="2.9,-7.5 2.9,-5 5.4,-5 	" />
            <path
              className="IconsAlerts-6"
              d="M5.4,6.9c0,0.3-0.2,0.5-0.5,0.5l0,0h-9.8c-0.3,0-0.5-0.2-0.5-0.5l0,0V-7c0-0.3,0.2-0.5,0.5-0.5h7.7		c0.1,0,0.2,0.1,0.3,0.1l2.1,2.1C5.4-5.2,5.4-5.1,5.4-5L5.4,6.9L5.4,6.9z"
            />
            <line className="IconsAlerts-6" x1="3.3" y1="-0.3" x2="-3.2" y2="-0.3" />
            <line className="IconsAlerts-6" x1="3.3" y1="1.7" x2="-3.2" y2="1.7" />
            <line className="IconsAlerts-6" x1="3.3" y1="3.8" x2="-3.2" y2="3.8" />
            <line className="IconsAlerts-6" x1="0.4" y1="-2.4" x2="-3.2" y2="-2.4" />
          </symbol>
          <symbol id="LA_file" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-000" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-010" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-000" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-000" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-000" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-000" x1="11.7" y1="0" x2="17.9" y2="0" />
            <polyline className="IconsAlerts-6" points="2.9,-7.5 2.9,-5 5.4,-5 	" />
            <path
              className="IconsAlerts-6"
              d="M5.4,6.9c0,0.3-0.2,0.5-0.5,0.5l0,0h-9.8c-0.3,0-0.5-0.2-0.5-0.5l0,0V-7c0-0.3,0.2-0.5,0.5-0.5h7.7		c0.1,0,0.2,0.1,0.3,0.1l2.1,2.1C5.4-5.2,5.4-5.1,5.4-5L5.4,6.9L5.4,6.9z"
            />
            <line className="IconsAlerts-6" x1="3.3" y1="-0.3" x2="-3.2" y2="-0.3" />
            <line className="IconsAlerts-6" x1="3.3" y1="1.7" x2="-3.2" y2="1.7" />
            <line className="IconsAlerts-6" x1="3.3" y1="3.8" x2="-3.2" y2="3.8" />
            <line className="IconsAlerts-6" x1="0.4" y1="-2.4" x2="-3.2" y2="-2.4" />
          </symbol>
          <symbol id="HA_host" viewBox="-24.1 -24.1 48.2 48.2">
            <circle id="_x39__1_" className="IconsAlerts-0" cx="0" cy="0" r="20.7" />
            <circle id="_x38__1_" className="IconsAlerts-1" cx="0" cy="0" r="16.9" />
            <line id="_x37__1_" className="IconsAlerts-0" x1="0" y1="-24.1" x2="0" y2="-15" />
            <line id="_x36__1_" className="IconsAlerts-0" x1="0" y1="15" x2="0" y2="24.1" />
            <line id="_x35__1_" className="IconsAlerts-0" x1="-15" y1="0" x2="-24.1" y2="0" />
            <line id="_x35__1_" className="IconsAlerts-0" x1="-15" y1="0" x2="24.1" y2="0" />
            <path id="_x34__1_" className="IconsAlerts-0" d="M24.1,0" />
            <path
              id="_x33__1_"
              className="IconsAlerts-2"
              d="M-3,6.7l-0.4,2.4c0,0.2,0.2,0.3,0.4,0.3h6c0.2,0,0.4-0.1,0.4-0.3L3,6.7"
            />
            <path
              id="_x32__1_"
              className="IconsAlerts-2"
              d="M8-8.9H-8c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0V3.6c0,0.7,0.6,1.3,1.3,1.3H8		c0.7,0,1.3-0.6,1.3-1.3c0,0,0,0,0,0V-7.5C9.3-8.3,8.7-8.9,8-8.9z"
            />
            <line id="_x31__1_" className="IconsAlerts-2" x1="-9.3" y1="2.5" x2="9.3" y2="2.5" />
          </symbol>
          <symbol id="MA_host" viewBox="-24.1 -24.1 48.2 48.2">
            <circle id="_x39__1_" className="IconsAlerts-00" cx="0" cy="0" r="20.7" />
            <circle id="_x38__1_" className="IconsAlerts-01" cx="0" cy="0" r="16.9" />
            <line id="_x37__1_" className="IconsAlerts-00" x1="0" y1="-24.1" x2="0" y2="-15" />
            <line id="_x36__1_" className="IconsAlerts-00" x1="0" y1="15" x2="0" y2="24.1" />
            <line id="_x35__1_" className="IconsAlerts-00" x1="-15" y1="0" x2="-24.1" y2="0" />
            <line id="_x35__1_" className="IconsAlerts-00" x1="-15" y1="0" x2="24.1" y2="0" />
            <path id="_x34__1_" className="IconsAlerts-00" d="M24.1,0" />
            <path
              id="_x33__1_"
              className="IconsAlerts-2"
              d="M-3,6.7l-0.4,2.4c0,0.2,0.2,0.3,0.4,0.3h6c0.2,0,0.4-0.1,0.4-0.3L3,6.7"
            />
            <path
              id="_x32__1_"
              className="IconsAlerts-2"
              d="M8-8.9H-8c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0V3.6c0,0.7,0.6,1.3,1.3,1.3H8		c0.7,0,1.3-0.6,1.3-1.3c0,0,0,0,0,0V-7.5C9.3-8.3,8.7-8.9,8-8.9z"
            />
            <line id="_x31__1_" className="IconsAlerts-2" x1="-9.3" y1="2.5" x2="9.3" y2="2.5" />
          </symbol>
          <symbol id="LA_host" viewBox="-24.1 -24.1 48.2 48.2">
            <circle id="_x39__1_" className="IconsAlerts-000" cx="0" cy="0" r="20.7" />
            <circle id="_x38__1_" className="IconsAlerts-010" cx="0" cy="0" r="16.9" />
            <line id="_x37__1_" className="IconsAlerts-000" x1="0" y1="-24.1" x2="0" y2="-15" />
            <line id="_x36__1_" className="IconsAlerts-000" x1="0" y1="15" x2="0" y2="24.1" />
            <line id="_x35__1_" className="IconsAlerts-000" x1="-15" y1="0" x2="-24.1" y2="0" />
            <line id="_x35__1_" className="IconsAlerts-000" x1="-15" y1="0" x2="24.1" y2="0" />
            <path id="_x34__1_" className="IconsAlerts-00" d="M24.1,0" />
            <path
              id="_x33__1_"
              className="IconsAlerts-2"
              d="M-3,6.7l-0.4,2.4c0,0.2,0.2,0.3,0.4,0.3h6c0.2,0,0.4-0.1,0.4-0.3L3,6.7"
            />
            <path
              id="_x32__1_"
              className="IconsAlerts-2"
              d="M8-8.9H-8c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0V3.6c0,0.7,0.6,1.3,1.3,1.3H8		c0.7,0,1.3-0.6,1.3-1.3c0,0,0,0,0,0V-7.5C9.3-8.3,8.7-8.9,8-8.9z"
            />
            <line id="_x31__1_" className="IconsAlerts-2" x1="-9.3" y1="2.5" x2="9.3" y2="2.5" />
          </symbol>
          <symbol id="HA_user" viewBox="-24.1 -24.1 48.2 48.2">
            <circle className="IconsAlerts-0" cx="0" cy="0" r="20.7" />
            <circle className="IconsAlerts-1" cx="0" cy="0" r="16.9" />
            <line className="IconsAlerts-0" x1="0" y1="-24.1" x2="0" y2="-15" />
            <line className="IconsAlerts-0" x1="0" y1="15" x2="0" y2="24.1" />
            <line className="IconsAlerts-0" x1="-15" y1="0" x2="-24.1" y2="0" />
            <line className="IconsAlerts-0" x1="15" y1="0" x2="24.1" y2="0" />
            <path
              className="IconsAlerts-2"
              d="M4.3,4.5C1.8,3.5-0.9,2.1-1.2,1.3V0.5C-0.6-0.2-0.2-1,0-1.9c0.6-0.5,0.7-1.4,0.2-2v-2c0-2-1-3.4-3.3-3.4		c-1.7-0.2-3.2,1.1-3.3,2.8c0,0.2,0,0.4,0,0.6v2c-0.4,0.6-0.3,1.5,0.2,2C-5.9-1.1-5.5-0.3-5,0.4v0.9c-0.2,0.8-3,2.2-5.5,3.2		c-0.2,0.1-0.4,0.3-0.4,0.6v2.2c0,0.3,0.2,0.6,0.6,0.6H4.1c0.3,0,0.6-0.3,0.5-0.6V5.1C4.7,4.9,4.6,4.7,4.3,4.5z"
            />
            <path
              className="IconsAlerts-2"
              d="M6.6,7.9h4.4c0.2,0,0.4-0.2,0.4-0.5c0,0,0,0,0,0V5.8c0-0.2-0.1-0.4-0.3-0.4c-2-0.8-4.1-1.8-4.3-2.5V2.2		c0.4-0.5,0.8-1.1,0.9-1.8C8.3,0,8.4-0.7,8-1.2v-1.5C8.2-4,7.3-5.1,6-5.3c-0.2,0-0.4,0-0.6,0C4.1-5.4,3-4.5,2.8-3.2		c0,0.2,0,0.3,0,0.5v1.5C2.5-0.7,2.6,0,3,0.4C3.2,1,3.5,1.7,3.9,2.2"
            />
          </symbol>
          <symbol id="MA_user" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-4" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-5" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-4" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-4" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-4" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-4" x1="11.7" y1="0" x2="17.9" y2="0" />
            <path
              className="IconsAlerts-6"
              d="M3.3,2.8c-2-0.9-4.3-1.9-4.5-2.6v-0.7c0.5-0.5,0.8-1.2,1-1.9C0.2-2.7,0.3-3.5,0-4v-1.5C0.1-6.8-0.9-8-2.2-8.2		c-0.2,0-0.4,0-0.6,0C-4.1-8.3-5.3-7.4-5.5-6c0,0.2,0,0.3,0,0.5V-4c-0.4,0.5-0.3,1.2,0.2,1.6c0.2,0.7,0.5,1.3,1,1.9v0.7		c-0.3,0.7-2.6,1.7-4.6,2.6C-9,2.9-9.2,3-9.2,3.2V5c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0,0H3.1c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0V3.2		C3.6,3,3.5,2.9,3.3,2.8z"
            />
            <path
              className="IconsAlerts-6"
              d="M5.1,5.5h3.6c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0,0V3.8c0-0.2-0.1-0.3-0.2-0.4C7.3,2.8,5.5,2,5.4,1.4V0.9		C5.7,0.5,6,0,6.1-0.5c0.4-0.3,0.5-0.8,0.2-1.2c0,0,0,0,0,0v-1.2c0.1-1-0.6-2-1.7-2.1C4.5-5,4.3-5,4.1-5c-1-0.1-2,0.6-2.1,1.6		c0,0.1,0,0.3,0,0.4v1.2C1.7-1.4,1.8-0.8,2.2-0.5c0,0,0,0,0,0c0.1,0.5,0.4,1,0.8,1.4"
            />
          </symbol>
          <symbol id="LA_user" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-000" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-010" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-000" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-000" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-000" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-000" x1="11.7" y1="0" x2="17.9" y2="0" />
            <path
              className="IconsAlerts-6"
              d="M3.3,2.8c-2-0.9-4.3-1.9-4.5-2.6v-0.7c0.5-0.5,0.8-1.2,1-1.9C0.2-2.7,0.3-3.5,0-4v-1.5C0.1-6.8-0.9-8-2.2-8.2		c-0.2,0-0.4,0-0.6,0C-4.1-8.3-5.3-7.4-5.5-6c0,0.2,0,0.3,0,0.5V-4c-0.4,0.5-0.3,1.2,0.2,1.6c0.2,0.7,0.5,1.3,1,1.9v0.7		c-0.3,0.7-2.6,1.7-4.6,2.6C-9,2.9-9.2,3-9.2,3.2V5c0,0.3,0.2,0.5,0.4,0.5c0,0,0,0,0,0H3.1c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0V3.2		C3.6,3,3.5,2.9,3.3,2.8z"
            />
            <path
              className="IconsAlerts-6"
              d="M5.1,5.5h3.6c0.2,0,0.4-0.2,0.4-0.4c0,0,0,0,0,0V3.8c0-0.2-0.1-0.3-0.2-0.4C7.3,2.8,5.5,2,5.4,1.4V0.9		C5.7,0.5,6,0,6.1-0.5c0.4-0.3,0.5-0.8,0.2-1.2c0,0,0,0,0,0v-1.2c0.1-1-0.6-2-1.7-2.1C4.5-5,4.3-5,4.1-5c-1-0.1-2,0.6-2.1,1.6		c0,0.1,0,0.3,0,0.4v1.2C1.7-1.4,1.8-0.8,2.2-0.5c0,0,0,0,0,0c0.1,0.5,0.4,1,0.8,1.4"
            />
          </symbol>
          <symbol id="MA_hoIconsAlerts-" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-4" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-5" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-4" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-4" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-4" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-4" x1="11.7" y1="0" x2="17.9" y2="0" />
            <path
              className="IconsAlerts-6"
              d="M-2.2,4.8l-0.3,1.8c0,0.1,0.1,0.2,0.3,0.2h4.3c0.1,0,0.3-0.1,0.3-0.2L2.1,4.8"
            />
            <path
              className="IconsAlerts-6"
              d="M5.8-6.5H-5.9c-0.6,0-1,0.4-1,1v8.1c0,0.6,0.4,1,1,1H5.8c0.6,0,1-0.4,1-1v-8.2C6.8-6.1,6.4-6.5,5.8-6.5z"
            />
            <line className="IconsAlerts-6" x1="-6.8" y1="1.8" x2="6.8" y2="1.8" />
          </symbol>
          <symbol id="HA_network" viewBox="-24.1 -24.1 48.2 48.2">
            <circle className="IconsAlerts-0" cx="0" cy="0" r="20.7" />
            <circle className="IconsAlerts-1" cx="0" cy="0" r="16.9" />
            <line className="IconsAlerts-0" x1="0" y1="-24.1" x2="0" y2="-15" />
            <line className="IconsAlerts-0" x1="0" y1="15" x2="0" y2="24.1" />
            <line className="IconsAlerts-0" x1="-15" y1="0" x2="-24.1" y2="0" />
            <line className="IconsAlerts-0" x1="15" y1="0" x2="24.1" y2="0" />
            <line className="IconsAlerts-2" x1="0.3" y1="2.1" x2="0.6" y2="8.5" />
            <line className="IconsAlerts-2" x1="-8" y1="4.8" x2="-1.8" y2="1.1" />
            <line className="IconsAlerts-2" x1="1.2" y1="-1.8" x2="3.6" y2="-5.4" />
            <line className="IconsAlerts-2" x1="6.8" y1="3.6" x2="1.8" y2="1.4" />
            <circle className="IconsAlerts-2" cx="8.4" cy="4.5" r="1.7" />
            <circle className="IconsAlerts-2" cx="0.1" cy="0.1" r="2.1" />
            <circle className="IconsAlerts-2" cx="0.1" cy="0.1" r="2.1" />
            <circle className="IconsAlerts-2" cx="4.4" cy="-6.6" r="1.6" />
            <circle className="IconsAlerts-2" cx="4.4" cy="-6.6" r="1.6" />
            <circle className="IconsAlerts-2" cx="0.5" cy="10.4" r="2.1" />
            <circle className="IconsAlerts-2" cx="0.5" cy="10.4" r="2.1" />
            <circle className="IconsAlerts-2" cx="-9.6" cy="5.7" r="2.1" />
            <circle className="IconsAlerts-2" cx="-9.6" cy="5.7" r="2.1" />
            <line className="IconsAlerts-2" x1="-1.4" y1="-1.6" x2="-4.5" y2="-4.2" />
            <circle className="IconsAlerts-2" cx="-5.6" cy="-5" r="1.6" />
            <circle className="IconsAlerts-2" cx="-5.6" cy="-5" r="1.6" />
          </symbol>
          <symbol id="MA_network" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-4" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-5" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-4" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-4" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-4" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-4" x1="11.7" y1="0" x2="17.9" y2="0" />
            <line className="IconsAlerts-6" x1="0.5" y1="0.4" x2="0.8" y2="5.6" />
            <line className="IconsAlerts-6" x1="-6.3" y1="2.6" x2="-1.2" y2="-0.5" />
            <line className="IconsAlerts-6" x1="1.3" y1="-2.9" x2="3.3" y2="-5.9" />
            <line className="IconsAlerts-6" x1="5.7" y1="1.1" x2="2" y2="-0.9" />
            <circle className="IconsAlerts-6" cx="7.2" cy="1.7" r="1.4" />
            <circle className="IconsAlerts-6" cx="0.4" cy="-1.3" r="1.7" />
            <circle className="IconsAlerts-6" cx="0.4" cy="-1.3" r="1.7" />
            <circle className="IconsAlerts-6" cx="3.9" cy="-6.9" r="1.4" />
            <circle className="IconsAlerts-6" cx="3.9" cy="-6.9" r="1.4" />
            <circle className="IconsAlerts-6" cx="0.8" cy="7.2" r="1.7" />
            <circle className="IconsAlerts-6" cx="0.8" cy="7.2" r="1.7" />
            <circle className="IconsAlerts-6" cx="-7.6" cy="3.3" r="1.7" />
            <circle className="IconsAlerts-6" cx="-7.6" cy="3.3" r="1.7" />
            <line className="IconsAlerts-6" x1="-1" y1="-2.7" x2="-3.6" y2="-4.9" />
            <circle className="IconsAlerts-6" cx="-4.3" cy="-5.6" r="1.3" />
            <circle className="IconsAlerts-6" cx="-4.3" cy="-5.6" r="1.3" />
          </symbol>
          <symbol id="LA_network" viewBox="-17.9 -17.9 35.7 35.7">
            <circle className="IconsAlerts-000" cx="0" cy="0" r="14.8" />
            <circle className="IconsAlerts-010" cx="0" cy="0" r="12.1" />
            <line className="IconsAlerts-000" x1="0" y1="-17.9" x2="0" y2="-11.7" />
            <line className="IconsAlerts-000" x1="0" y1="11.7" x2="0" y2="17.9" />
            <line className="IconsAlerts-000" x1="-11.7" y1="0" x2="-17.9" y2="0" />
            <line className="IconsAlerts-000" x1="11.7" y1="0" x2="17.9" y2="0" />
            <line className="IconsAlerts-6" x1="0.5" y1="0.4" x2="0.8" y2="5.6" />
            <line className="IconsAlerts-6" x1="-6.3" y1="2.6" x2="-1.2" y2="-0.5" />
            <line className="IconsAlerts-6" x1="1.3" y1="-2.9" x2="3.3" y2="-5.9" />
            <line className="IconsAlerts-6" x1="5.7" y1="1.1" x2="2" y2="-0.9" />
            <circle className="IconsAlerts-6" cx="7.2" cy="1.7" r="1.4" />
            <circle className="IconsAlerts-6" cx="0.4" cy="-1.3" r="1.7" />
            <circle className="IconsAlerts-6" cx="0.4" cy="-1.3" r="1.7" />
            <circle className="IconsAlerts-6" cx="3.9" cy="-6.9" r="1.4" />
            <circle className="IconsAlerts-6" cx="3.9" cy="-6.9" r="1.4" />
            <circle className="IconsAlerts-6" cx="0.8" cy="7.2" r="1.7" />
            <circle className="IconsAlerts-6" cx="0.8" cy="7.2" r="1.7" />
            <circle className="IconsAlerts-6" cx="-7.6" cy="3.3" r="1.7" />
            <circle className="IconsAlerts-6" cx="-7.6" cy="3.3" r="1.7" />
            <line className="IconsAlerts-6" x1="-1" y1="-2.7" x2="-3.6" y2="-4.9" />
            <circle className="IconsAlerts-6" cx="-4.3" cy="-5.6" r="1.3" />
            <circle className="IconsAlerts-6" cx="-4.3" cy="-5.6" r="1.3" />
          </symbol>
          /*Multiple alerts */
          <symbol id="Multiple_user_alert" data-name="Multiple user alert" viewBox="0 0 48.27 48.16">
            <g id="HA-user-off">
              <circle className="IconsAlerts-10" cx="24.19" cy="24.08" r="20.68" />
              <circle className="IconsAlerts-11" cx="24.19" cy="24.08" r="16.85" />
              <line className="IconsAlerts-10" x1="24.19" x2="24.19" y2="9.11" />
              <line className="IconsAlerts-10" x1="24.19" y1="39.05" x2="24.19" y2="48.16" />
              <line className="IconsAlerts-10" x1="9.22" y1="24.08" x2="0.11" y2="24.08" />
              <line className="IconsAlerts-10" x1="39.16" y1="24.08" x2="48.27" y2="24.08" />
              <path
                className="IconsAlerts-9"
                d="M28.53,28.63c-2.5-1.07-5.27-2.4-5.5-3.23v-.87a5.71,5.71,0,0,0,1.17-2.37,1.51,1.51,0,0,0,.24-2V18.16c0-2-1-3.39-3.31-3.39a3.05,3.05,0,0,0-3.31,3.39v1.95a1.51,1.51,0,0,0,.24,2,5.7,5.7,0,0,0,1.17,2.37v.87c-.23.83-3,2.16-5.5,3.23a.62.62,0,0,0-.35.58v2.18a.59.59,0,0,0,.55.62H28.33a.59.59,0,0,0,.55-.62V29.21A.62.62,0,0,0,28.53,28.63Z"
              />
              <path
                className="IconsAlerts-9"
                d="M30.83,32h4.45a.45.45,0,0,0,.43-.47V29.87a.48.48,0,0,0-.28-.44c-2-.82-4.13-1.84-4.31-2.48v-.67A4.36,4.36,0,0,0,32,24.46a1.14,1.14,0,0,0,.19-1.57V21.4a2.34,2.34,0,0,0-2.6-2.6A2.36,2.36,0,0,0,27,21.4v1.49a1.14,1.14,0,0,0,.19,1.57,4.34,4.34,0,0,0,.92,1.82"
              />
            </g>
            <path className="IconsAlerts-8" d="M3.49,5.08H0V3.56H3.49V.05H5V3.56H8.51V5.08H5V8.57H3.49Z" />
          </symbol>
          <symbol id="Multiple_file_alert" data-name="Multiple file alert" viewBox="0 0 48.27 48.16">
            <g id="HA_file-off" data-name="HA file-off">
              <circle className="IconsAlerts-7" cx="24.19" cy="24.08" r="20.68" />
              <circle className="IconsAlerts-8" cx="24.19" cy="24.08" r="16.85" />
              <line className="IconsAlerts-7" x1="24.19" x2="24.19" y2="9.11" />
              <line className="IconsAlerts-7" x1="24.19" y1="39.05" x2="24.19" y2="48.16" />
              <line className="IconsAlerts-7" x1="9.22" y1="24.08" x2="0.11" y2="24.08" />
              <line className="IconsAlerts-7" x1="39.16" y1="24.08" x2="48.27" y2="24.08" />
              <polyline className="IconsAlerts-9" points="28.27 13.31 28.27 17.03 31.99 17.03" />
              <path
                className="IconsAlerts-9"
                d="M32,34.11a.74.74,0,0,1-.74.74H17.12a.74.74,0,0,1-.73-.74V14.06a.74.74,0,0,1,.73-.75H28.27a.54.54,0,0,1,.42.22l3.08,3A.61.61,0,0,1,32,17Z"
              />
              <line className="IconsAlerts-9" x1="28.85" y1="23.69" x2="19.52" y2="23.69" />
              <line className="IconsAlerts-9" x1="28.85" y1="26.67" x2="19.52" y2="26.67" />
              <line className="IconsAlerts-9" x1="28.85" y1="29.65" x2="19.52" y2="29.65" />
              <line className="IconsAlerts-9" x1="24.7" y1="20.71" x2="19.52" y2="20.71" />
            </g>
            <path className="IconsAlerts-8" d="M3.49,5.08H0V3.56H3.49V.05H5V3.56H8.51V5.08H5V8.57H3.49Z" />
          </symbol>
          <symbol id="Multiple_network_alert" data-name="Multiple network alert" viewBox="0 0 48.27 48.16">
            <g id="HA_network-off" data-name="HA network-off">
              <circle className="IconsAlerts-7" cx="24.19" cy="24.08" r="20.68" />
              <circle className="IconsAlerts-8" cx="24.19" cy="24.08" r="16.85" />
              <line className="IconsAlerts-7" x1="24.19" x2="24.19" y2="9.11" />
              <line className="IconsAlerts-7" x1="24.19" y1="39.05" x2="24.19" y2="48.16" />
              <line className="IconsAlerts-7" x1="9.22" y1="24.08" x2="0.11" y2="24.08" />
              <line className="IconsAlerts-7" x1="39.16" y1="24.08" x2="48.27" y2="24.08" />
              <line className="IconsAlerts-9" x1="24.47" y1="25.22" x2="24.78" y2="31.54" />
              <line className="IconsAlerts-9" x1="16.17" y1="27.91" x2="22.37" y2="24.14" />
              <line className="IconsAlerts-9" x1="25.38" y1="21.31" x2="27.78" y2="17.71" />
              <line className="IconsAlerts-9" x1="30.96" y1="26.65" x2="26.01" y2="24.5" />
              <circle className="IconsAlerts-9" cx="32.61" cy="27.55" r="1.74" />
              <circle className="IconsAlerts-9" cx="24.28" cy="23.15" r="2.09" />
              <circle className="IconsAlerts-9" cx="24.28" cy="23.15" r="2.09" />
              <circle className="IconsAlerts-9" cx="28.57" cy="16.43" r="1.62" />
              <circle className="IconsAlerts-9" cx="28.57" cy="16.43" r="1.62" />
              <circle className="IconsAlerts-9" cx="24.74" cy="33.46" r="2.09" />
              <circle className="IconsAlerts-9" cx="24.74" cy="33.46" r="2.09" />
              <circle className="IconsAlerts-9" cx="14.63" cy="28.79" r="2.09" />
              <circle className="IconsAlerts-9" cx="14.63" cy="28.79" r="2.09" />
              <line className="IconsAlerts-9" x1="22.77" y1="21.52" x2="19.64" y2="18.86" />
              <circle className="IconsAlerts-9" cx="18.6" cy="18.05" r="1.62" />
              <circle className="IconsAlerts-9" cx="18.6" cy="18.05" r="1.62" />
            </g>
            <path className="IconsAlerts-8" d="M3.49,5H0V3.53H3.49V0H5V3.53H8.51V5H5V8.54H3.49Z" />
          </symbol>
          <symbol id="Multiple_host_alert" data-name="Multiple host alert" viewBox="0 0 48.27 48.23">
            <circle className="IconsAlerts-7" cx="24.19" cy="24.15" r="20.68" />
            <circle className="IconsAlerts-8" cx="24.19" cy="24.15" r="16.85" />
            <line className="IconsAlerts-7" x1="24.19" y1="0.07" x2="24.19" y2="9.19" />
            <line className="IconsAlerts-7" x1="24.19" y1="39.12" x2="24.19" y2="48.23" />
            <line className="IconsAlerts-7" x1="9.22" y1="24.15" x2="0.11" y2="24.15" />
            <line className="IconsAlerts-7" x1="39.16" y1="24.15" x2="48.27" y2="24.15" />
            <path
              className="IconsAlerts-9"
              d="M21.19,30.82l-.39,2.41a.36.36,0,0,0,.39.32h6a.36.36,0,0,0,.39-.32l-.39-2.41"
            />
            <path
              className="IconsAlerts-9"
              d="M32.21,15.28h-16a1.31,1.31,0,0,0-1.32,1.32V27.76a1.32,1.32,0,0,0,1.32,1.33h16a1.32,1.32,0,0,0,1.32-1.33V16.6A1.31,1.31,0,0,0,32.21,15.28Z"
            />
            <line className="IconsAlerts-9" x1="14.86" y1="26.65" x2="33.53" y2="26.65" />
            <path className="IconsAlerts-8" d="M3.49,5H0V3.51H3.49V0H5V3.51H8.51V5H5V8.52H3.49Z" />
          </symbol>
          <symbol id="internal_comm_alert" data-name="internal comm alert" viewBox="0 0 48.16 48.16">
            <g id="HA_host-off" data-name="HA host-off">
              <circle className="IconsAlerts-7" cx="24.08" cy="24.08" r="20.68" />
              <circle className="IconsAlerts-8" cx="24.08" cy="24.08" r="16.85" />
              <line className="IconsAlerts-7" x1="24.08" x2="24.08" y2="9.11" />
              <line className="IconsAlerts-7" x1="24.08" y1="39.05" x2="24.08" y2="48.16" />
              <line className="IconsAlerts-7" x1="9.11" y1="24.08" y2="24.08" />
              <line className="IconsAlerts-7" x1="39.05" y1="24.08" x2="48.16" y2="24.08" />
            </g>
            <circle className="IconsAlerts-12" cx="24.08" cy="24.08" r="1.5" />
            <path className="IconsAlerts-9" d="M15.75,15.65a11.52,11.52,0,0,0,0,16.86" />
            <path className="IconsAlerts-9" d="M19.24,28.42a5.76,5.76,0,0,1,0-8.69" />
            <path className="IconsAlerts-9" d="M32.41,32.51a11.52,11.52,0,0,0,0-16.86" />
            <path className="IconsAlerts-9" d="M28.92,19.73a5.76,5.76,0,0,1,0,8.69" />
          </symbol>
          <symbol id="multiple_internal_comm_alert" data-name="multiple internal comm alert" viewBox="0 0 48.4 48.16">
            <circle className="IconsAlerts-7" cx="24.32" cy="24.08" r="20.68" />
            <circle className="IconsAlerts-8" cx="24.32" cy="24.08" r="16.85" />
            <line className="IconsAlerts-7" x1="24.32" x2="24.32" y2="9.11" />
            <line className="IconsAlerts-7" x1="24.32" y1="39.05" x2="24.32" y2="48.16" />
            <line className="IconsAlerts-7" x1="9.36" y1="24.08" x2="0.24" y2="24.08" />
            <line className="IconsAlerts-7" x1="39.29" y1="24.08" x2="48.4" y2="24.08" />
            <circle className="IconsAlerts-12" cx="24.32" cy="24.08" r="1.5" />
            <path className="IconsAlerts-9" d="M16,15.65a11.52,11.52,0,0,0,0,16.86" />
            <path className="IconsAlerts-9" d="M19.49,28.42a5.76,5.76,0,0,1,0-8.69" />
            <path className="IconsAlerts-9" d="M32.65,32.51a11.52,11.52,0,0,0,0-16.86" />
            <path className="IconsAlerts-9" d="M29.16,19.73a5.76,5.76,0,0,1,0,8.69" />
            <path className="IconsAlerts-8" d="M3.49,5.62H0V4.1H3.49V.59H5V4.1H8.51V5.62H5V9.11H3.49Z" />
          </symbol>
          <symbol id="external_comm_alert" data-name="external comm alert" viewBox="0 0 48.16 48.16">
            <circle className="IconsAlerts-7" cx="24.08" cy="24.08" r="20.68" />
            <circle className="IconsAlerts-8" cx="24.08" cy="24.08" r="16.85" />
            <line className="IconsAlerts-7" x1="24.08" x2="24.08" y2="9.11" />
            <line className="IconsAlerts-7" x1="24.08" y1="39.05" x2="24.08" y2="48.16" />
            <line className="IconsAlerts-7" x1="9.11" y1="24.08" y2="24.08" />
            <line className="IconsAlerts-7" x1="39.05" y1="24.08" x2="48.16" y2="24.08" />
            <circle className="IconsAlerts-12" cx="23.99" cy="32.3" r="1.5" />
            <path className="IconsAlerts-2" d="M32.07,23.34a11.12,11.12,0,0,0-16.16,0" />
            <path className="IconsAlerts-2" d="M36,19.46a16.69,16.69,0,0,0-24,0" />
            <path className="IconsAlerts-2" d="M19.82,27.22a5.56,5.56,0,0,1,8.33,0" />
          </symbol>
          <symbol id="multiple_external_comm_alert" data-name="multiple external comm alert" viewBox="0 0 48.4 48.16">
            <g id="internal_comm_alert-4" data-name="internal comm alert">
              <g id="HA_host-off-3" data-name="HA host-off">
                <circle className="IconsAlerts-7" cx="24.32" cy="24.08" r="20.68" />
                <circle className="IconsAlerts-8" cx="24.32" cy="24.08" r="16.85" />
                <line className="IconsAlerts-7" x1="24.32" x2="24.32" y2="9.11" />
                <line className="IconsAlerts-7" x1="24.32" y1="39.05" x2="24.32" y2="48.16" />
                <line className="IconsAlerts-7" x1="9.36" y1="24.08" x2="0.24" y2="24.08" />
                <line className="IconsAlerts-7" x1="39.29" y1="24.08" x2="48.4" y2="24.08" />
              </g>
            </g>
            <path className="IconsAlerts-8" d="M3.49,5.62H0V4.1H3.49V.59H5V4.1H8.51V5.62H5V9.11H3.49Z" />
            <circle className="IconsAlerts-12" cx="24.23" cy="32.17" r="1.5" />
            <path className="IconsAlerts-2" d="M32.31,23.2a11.12,11.12,0,0,0-16.16,0" />
            <path className="IconsAlerts-2" d="M36.23,19.32a16.69,16.69,0,0,0-24,0" />
            <path className="IconsAlerts-2" d="M20.07,27.08a5.56,5.56,0,0,1,8.33,0" />
          </symbol>
        </defs>
      </svg>
    );
  }
}

export default IconsAlerts;
